import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from 'embeds/components';

const styles = (theme) => ({
  root: {
    fontWeight: 600,
    fontSize: 15,
    lineHeight: '21px',
    color: theme.palette.text.primary,
  },
});

class PatientJourneyCardTitle extends Component {
  render() {
    const { classes, event, patient } = this.props;
    if (!event || !patient) {
      return <span />;
    }
    const {
      type,
      isFuture,
      details: { status, lumabot },
    } = event;
    const { firstname: name } = patient;

    let title;
    if (type === 'diagnoses') {
      title = `${name} ${isFuture ? 'has' : 'was given'} a diagnosis`;
    } else if (type === 'procedures') {
      title = `${name} ${isFuture ? 'has' : 'had'} a procedure`;
    } else if (type === 'appointments') {
      title = `${name} ${isFuture ? 'has' : 'had'} an appointment`;
    } else if (type === 'recalls') {
      title = `${name} ${isFuture ? 'has' : 'had'} a recall`;
    } else if (type === 'referrals' && status === 'active') {
      title = `Referral created for ${name}`;
      // TODO: Add check for status === 'scheduled' if/ after we have a copy for canceled and closed referrals
    } else if (type === 'referrals' && status !== 'active') {
      title = `${name} scheduled an appointment via referral`;
    } else if (type === 'feedbackResponses') {
      title = `${name} submitted feedback`;
    } else if (type === 'insurances') {
      title = `${name} uploaded their insurance`;
    } else if (type === 'patientForms') {
      title = `${name} uploaded their forms`;
      if (event.details.patientFormTemplateType === 'ccda') title = `${name} uploaded their CCDA form`;
      if (lumabot) title = `${name} uploaded their LumaBot flow`;
    } else if (type === 'billingTransactions') {
      title = `${name} was sent a charge`;
    }

    return (
      <Typography className={classes.root} gutterBottom>
        {title}
      </Typography>
    );
  }
}

PatientJourneyCardTitle.propTypes = {
  classes: PropTypes.object.isRequired,
  event: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).isRequired,
  patient: PropTypes.object,
};

export default withStyles(styles)(PatientJourneyCardTitle);
